import type { SupportShop, TenantAccess } from "@/lib/api/types"
import { mainPb } from "@/lib/pb/clients"
import { ensureMainSession } from "@/lib/pb/session"

/**
 * The support account's way into any shop (MANIT-1024).
 *
 * MainApp answers these only to the support account, recognised by its own
 * settings rather than anything the client says, and logs every shop opened
 * this way. Everyone else is told the routes do not exist.
 */

/** The fewest letters MainApp will search on. */
export const SUPPORT_SEARCH_MIN = 2

/** Active shops whose name or booking address matches, best first. */
export async function searchSupportShops(query: string): Promise<SupportShop[]> {
  await ensureMainSession()
  const answer = await mainPb.send<{ items: SupportShop[] }>(
    `/api/support/tenants?q=${encodeURIComponent(query)}`,
    { method: "GET" },
  )
  return answer.items
}

/** One shop, for reopening the one support was last in. */
export async function fetchSupportShop(id: string): Promise<SupportShop> {
  await ensureMainSession()
  return mainPb.send<SupportShop>(`/api/support/tenants/${encodeURIComponent(id)}`, {
    method: "GET",
  })
}

/**
 * A shop opened as support, in the shape the dashboard works from. The role
 * is what the shop's server seats support as; owning it is never support's.
 */
export function supportAccess(shop: SupportShop): TenantAccess {
  return {
    id: shop.id,
    name: shop.name,
    slug: shop.slug,
    serverUrl: shop.serverUrl,
    role: "ADMIN",
    capacity: "staff",
    isOwner: false,
    ownerId: shop.ownerId,
    timezone: shop.timezone,
    currency: shop.currency,
    support: true,
  }
}
